var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTv = function SvgTv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 21.2 19.2"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.6 19.2a.6.6 0 1 0 0-1.2v1.2M4.6 18a.6.6 0 1 0 0 1.2V18M3.6.6v.6h14V0h-14zm17 3H20v8h1.2v-8zm-3 11V14h-14v1.2h14zm-17-3h.6v-8H0v8zm3 3V14a2.4 2.4 0 0 1-2.4-2.4H0a3.6 3.6 0 0 0 3.6 3.6zm17-3H20a2.4 2.4 0 0 1-2.4 2.4v1.2a3.6 3.6 0 0 0 3.6-3.6zm-3-11v.6A2.4 2.4 0 0 1 20 3.6h1.2A3.6 3.6 0 0 0 17.6 0zm-14 0V0A3.6 3.6 0 0 0 0 3.6h1.2a2.4 2.4 0 0 1 2.4-2.4zm13 18V18h-12v1.2h12z"
  })));
};
export default SvgTv;